import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css';


$("document").ready(function() {
  
  
  
  if ($('.triggerTeszt').length > 0) {
    $('.triggerTeszt').click(function() {
        $(this).hide();
        $('.contactForm').slideToggle(); 
        return false;
    });
  }
  if ($('.mapbox').length > 0) {
    $('.mapbox .hotspot').click(function() {
      var what = $(this).data('target');
      $('.mapbox .hotspot').removeClass('active');
      $(this).addClass("active");
      $('.accordion').removeClass('active');
      $(what).addClass('active');

      $([document.documentElement, document.body]).animate({
          scrollTop: $(what).offset().top
      },1000);

      return false;
    });

    $('.accordion').click(function() {
      var targeting = "#"+$(this).attr('id');
      if($(this).hasClass('active')) {
        $(this).removeClass('active');
        $('.mapbox .hotspot').removeClass('active');
      } else {
        $('.accordion').removeClass('active');
        $(this).addClass('active');
        $('.mapbox .hotspot').removeClass('active');
        $('[data-target="'+targeting+'"]').addClass("active");
      }
      
      
      return false;
    });

  }
  if ($('.contactForm').length > 0) {
    $("input:radio").each(function (i) {
      this.checked = false;      
    });
    var days = 0; 
    var currentDays = 0;
    $('#input_1_2 input').click(function() {
      currentDays = parseInt($(this).val());
      $(this).parent().parent().parent().parent().parent().find('.formBtn').addClass('active');
    });
    $('#input_1_3 input').click(function() {
      currentDays = parseInt($(this).val());
      $(this).parent().parent().parent().parent().parent().find('.formBtn').addClass('active');
    });
    $('#input_1_4 input').click(function() {
      currentDays = parseInt($(this).val());
      $(this).parent().parent().parent().parent().parent().find('.formBtn').addClass('active');
    });
    $('#input_1_5 input').click(function() {      
      currentDays = parseInt($(this).val());
      $(this).parent().parent().parent().parent().parent().find('.formBtn').addClass('active');
    });
    var prevDays = 0;
    $('#input_1_6 input').click(function() {      
      days -= prevDays;
      currentDays = parseInt($(this).val());
      days += currentDays;
      prevDays = currentDays;
      
      $('#input_1_1').val(days);
      $(".gform_footer").show();
    });
    $('.formBtn').click(function() {    
      if($(this).hasClass('active')) {
        var what = $(this).data('target');
        $('.questionBox').hide();
        $('#step-'+what).show();
        days += currentDays;
      }

      return false;
    });
    /*
    <a href="#" class="formBtn" data-target="5">Következő</a>
<span class="status">4/5</span>
</div>
</div>
<div class="questionBox question" id="step-5"><div>
    */
    /*$('#input_1_2 input').click(function() {
      $("#field_1_2").hide();
      $("#field_1_3").show();
      days += parseInt($(this).val());
      console.log(days);
      $('#input_1_1').val(days);
    });
    $('#input_1_3 input').click(function() {
      $("#field_1_3").hide();
      $("#field_1_4").show();
      days += parseInt($(this).val());
      console.log(days);
      $('#input_1_1').val(days);
    });
    $('#input_1_4 input').click(function() {
      $("#field_1_4").hide();
      $("#field_1_5").show();
      days += parseInt($(this).val());
      console.log(days);
      $('#input_1_1').val(days);
    });
    $('#input_1_5 input').click(function() {      
      days += parseInt($(this).val());
      console.log(days);
      $('#input_1_1').val(days);
      $(".gform_footer").show();
    });*/
  }

  $('.hamburger-lines').click(function() {
    $(this).toggleClass('active');
      $('.mobileMenu').toggleClass('active');

      return false;
  });
  $('.mobileMenu a').click(function() {
      $('.hamburger-lines').toggleClass('active');
      $('.mobileMenu').toggleClass('active');


  });
  
  if ($('.map').length > 0) {
  /**Map */
  let mymap = L.map('mapid').setView([46.9851218,19.1352595], 8);


  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    maxZoom: 18,
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
  }).addTo(mymap); 


  let markers = [];
  if(map_options){
    Array.prototype.forEach.call(map_options, opt => {
      if(opt.koords){
        Array.prototype.forEach.call(opt.koords, kord => {
          let latlong = kord.kord.split(',');
          let latitude = parseFloat(latlong[0]);
          let longitude = parseFloat(latlong[1]);
          markers.push(L.marker([latitude, longitude],{
            'spec': opt.spec,
            'title': `${opt.title}`,
            'image': opt.image,
            'link': opt.link
          }).addTo(mymap).bindPopup(`<img src="${opt.image}"> <strong> ${opt.title} </strong> <br /> ${kord.address} <br />  <a target="_blank" target="_blank" href="${opt.link}">Tovább </a>`));
        })
      }
    })
  }

  const searchby = document.querySelector('.searchby')
  if(searchby){
    searchby.addEventListener('keyup', e => {
      markers.forEach(marker => {
        if(e.target.value == ''){
          return mymap.addLayer(marker);
        }
        const { value } = e.target
        const getSelectValue = document.querySelector('.select-selected')
        
        let searchBy = 'spec';
        if(getSelectValue.innerHTML == 'Név'){
          searchBy = 'title';
        }
        
        if(!Array.isArray(marker.options[searchBy])){
          if(!marker.options[searchBy].includes(value.toLowerCase())){
            mymap.removeLayer(marker);
          }else{
            return mymap.addLayer(marker);
          }
        }else{
          if(marker.options[searchBy].some(element => element.includes(value.toLowerCase()))){
            return mymap.addLayer(marker);
          }else{
            mymap.removeLayer(marker);
          }
        }
      });
    })
  } 
  respMapSize(mymap)
  window.addEventListener('resize', function(){
    respMapSize(mymap)
  })

  function respMapSize(mymap){
    let width = document.documentElement.clientWidth;
      if (width < 991) {
        mymap.setZoom(7);
    }  else {
        mymap.setZoom(8);
    }
  }


} // end of map

  /*
  if ($('.appartmentCarousel').length > 0) {

    $('.appartmentCarousel').slick({
          dots: false,
          arrows: true,
          infinite: true,
          speed: 300,
        //  variableWidth: true,
        fade:true,
          slidesToShow: 1,
          slidesToScroll: 1,
          responsive: [
            {
                breakpoint: 1200,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                dots: false,
                arrows: true
      
                }
            },
            {
                breakpoint: 575,
                settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                arrows: true
      
                }
            },
        ]
    });

}
if ($('.dualCarousel').length > 0) {

  $('.dualCarousel').slick({
        dots: false,
        arrows: true,
        infinite: true,
        speed: 300,
      //  variableWidth: true,
        slidesToShow:3,
        slidesToScroll: 3,
        responsive: [
          {
              breakpoint: 1200,
              settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              dots: false,
              arrows: true
    
              }
          },
          {
              breakpoint: 575,
              settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: false,
              arrows: true
    
              }
          },
      ]
  });

}
if ($('.interiorCarousel').length > 0) {

    $('.interiorCarousel').slick({
          dots: false,
          arrows: true,
          infinite: true,
          speed: 300,
        //  variableWidth: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          responsive: [
            {
                breakpoint: 1200,
                settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                dots: false,
                arrows: true
      
                }
            },
            {
                breakpoint: 575,
                settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                arrows: true
      
                }
            },
        ]
    });

}
if ($('.scheduleCarousel').length > 0) {

    $('.scheduleCarousel').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
      {
          breakpoint: 1200,
          settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: true

          }
      }

      ]
  });

}


if ($('.gallery').length > 0) {

    $('a.gallery').featherlightGallery({
      previousIcon: '&#9664;',     
      nextIcon: '&#9654;',         
      galleryFadeIn: 100,          
      galleryFadeOut: 300          
    });
}
if ($('.accordion').length > 0) {
    $('.accordionHeader').click(function() { 
        $(this).parent().toggleClass('active');
        $(this).parent().find('.accordionContent').slideToggle();

        
        return false;
    });                
}

if ($('.teamSection').length > 0) {
  $('.teamSection .trigger').click(function() {
    $(this).parent().find('.details').slideToggle();
    return false;
  });
}
if ($('.showAccordions').length > 0) {
  $('.showAccordions').click(function() {
    $('#specs').slideToggle();
    return false;
  });
}


  if ($('.flexslider').length > 0) {
    $('.flexslider').flexslider({
      animation: "fade",
      
      directionNav: false,
      animationLoop: true,
      controlNav: true,
      pauseOnHover: false,
      prevText: "",
      nextText: ""
  });
  }
*/
  
  $('a[href*="#"]:not([href="#"])').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
            $('html, body').animate({
            scrollTop: target.offset().top-100
            }, 1000);
            return false;
        }
      }
    }); 

}); 